module.exports = __webpack_public_path__ + "static/media/img-8273c39e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/mdf-logo.png
// module id = 5293
// module chunks = 39